export default {
    GET_CONTRACTORS_REQUEST: state => {
        state.outdoorsLocalizationContractorsLoading = true
    },
    GET_CONTRACTORS_SUCCESS: (state, data) => {
        state.outdoorsLocalizationContractors = data.results
        state.outdoorsLocalizationContractorsLoading = false
    },
    GET_CONTRACTORS_FAILURE: state => {
        state.outdoorsLocalizationContractorsLoading = false
    },
    SET_CONTRACTORS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_CONTRACTORS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}